import { defineStore } from 'pinia'

import type { SettingsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useSettingsStore = defineStore('settings', {
  state: (): SettingsStore => ({
    loading: false,
    settings: {},
    experiments: {},
    configVaultUrl: '',
  }),
  actions,
  getters,
})
